<script setup>
import BackButtonComponent from "@/components/utils/BackButtonComponent.vue";
import { onMounted, ref } from "vue";
import LoadingComponent from "@/components/utils/LoadingComponent.vue";
import { getUser, updateUser } from "@/services/userService";
import { useRoute } from "vue-router";
import { customToast } from "@/globals/utils/customToast";
import DefaultButton from "@/components/utils/DefaultButton.vue";

const user = ref({});
const error = ref(null);
const route = useRoute();
const editing = ref(false);
const id = route.params.id;

const fetchUser = async () => {
  try {
    user.value = await getUser(id);
  } catch (err) {
    error.value = "Error al cargar los datos del usuario.";
    console.error(err);
  }
};

const enableDisableEdit = () => {
  editing.value = !editing.value;
};

const _updateUser = async () => {
  try {
    await updateUser(id, user.value);
    editing.value = false;
    customToast("Usuario actualizado correctamente.", "success");
  } catch (err) {
    error.value = "Error al actualizar el usuario.";
    customToast("Error al actualizar el usuario.", "error");
  }
};

onMounted(() => {
  fetchUser();
});
</script>

<template>
  <BackButtonComponent url="/users" />
  <div class="flex justify-center items-start bg-gray-100 dark:bg-gray-800 px-4 pt-5">
    <div class="w-full max-w-4xl p-8 bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 rounded shadow-lg">
      <LoadingComponent v-if="!user" />
      <div v-else>
        <form @submit.prevent="_updateUser" class="space-y-6">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">

            <!-- Name -->
            <div>
              <label for="name" class="block text-sm font-medium text-gray-700 dark:text-gray-200">Name</label>
              <input
                  type="text"
                  id="name"
                  v-model="user.name"
                  class="mt-1 block w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-gray-200"
                  required
                  :disabled="!editing"
              />
            </div>

            <!-- Email -->
            <div>
              <label for="email" class="block text-sm font-medium text-gray-700 dark:text-gray-200">Email</label>
              <input
                  type="email"
                  id="email"
                  v-model="user.email"
                  class="mt-1 block w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-gray-200"
                  required
                  :disabled="!editing"
              />
            </div>

            <!-- Rating -->
            <div>
              <label for="rating" class="block text-sm font-medium text-gray-700 dark:text-gray-200">Rating</label>
              <input
                  type="number"
                  id="rating"
                  v-model="user.rating"
                  min="1"
                  max="5"
                  class="mt-1 block w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-gray-200"
                  required
                  :disabled="!editing"
              />
            </div>

            <!-- Phone -->
            <div>
              <label for="phone" class="block text-sm font-medium text-gray-700 dark:text-gray-200">Phone</label>
              <input
                  type="tel"
                  id="phone"
                  v-model="user.phone"
                  pattern="^\+?[0-9\- ]{7,15}$"
                  class="mt-1 block w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-gray-200"
                  required
                  :disabled="!editing"
              />
            </div>
          </div>

          <!-- Submit Button -->
          <div class="text-center mt-6">
            <DefaultButton :title=" editing ? `Cancel` : `Edit`" @click.prevent="enableDisableEdit"  :class="editing?'mr-2':''"  />
            <DefaultButton title="Save"    v-if="editing" type="submit" />
          </div>
        </form>
        <div v-if="error" class="mt-4 text-center text-red-500 dark:text-red-400">
          {{ error }}
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
/* Estilos adicionales si es necesario */
</style>
